import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radio', 'section']

  declare readonly radioTargets: HTMLInputElement[]
  declare readonly sectionTargets: HTMLElement[]

  connect (): void {
    this.showMatchingSection()
  }

  showMatchingSection (): void {
    const selected = this.radioTargets.find(r => r.checked)?.value

    this.sectionTargets.forEach(section => {
      const values = section.dataset.value?.split(',') ?? []
      const hidden = !values.includes(selected ?? '')
      section.classList.toggle('hidden', hidden)
      section.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>('input, select, textarea').forEach(input => {
        input.disabled = hidden
      })
    })
  }
}
